/**
 * Ce qu'un élève en checkpoint dit à la salle de sa conversation : l'attribut LiveKit `checkpoint_context`, posé à côté
 * de `ongoing_checkpoint` par la salle de l'élève, lu par celle du tuteur (un quiz de prérequis n'y est jamais le
 * champion). Sa valeur pour le quiz est celle que le serveur range dans `trigger_context` (`PREREQUISITE_QUIZ_CONTEXT`).
 */
export { PREREQUISITE_QUIZ_CONTEXT } from "../../activity/prerequisite/prerequisiteGate"

export const CHECKPOINT_CONTEXT_ATTRIBUTE = "checkpoint_context"
